import { registerPlugin } from '@capacitor/core';

interface IHideablePlugin {
  hide: () => Promise<void>;
}

/**
 * Old APKs (Capacitor 5 era) bundled the StatusBar and NavigationBar native
 * modules and relied on the web bundle to hide both at startup (the deleted
 * CapacitorFullScreen helper). The new binary hides the bars natively, but a
 * legacy shell loading this bundle would keep them visible — a real problem
 * on kiosk devices. `registerPlugin` reaches the still-present native
 * modules without their (removed) npm wrappers; on anything but a legacy
 * shell this must never be called.
 */
export function applyLegacyShellFullscreen(): void {
  const statusBar = registerPlugin<IHideablePlugin>('StatusBar');
  const navigationBar = registerPlugin<IHideablePlugin>('NavigationBar');
  statusBar.hide().catch((err) => console.error(err));
  navigationBar.hide().catch((err) => console.error(err));
}
